import React, { Component } from 'react';
import './Grid.css';
import { DataphiGrid } from 'dataphi-react-components/dist/Containers/Grid/DataphiGrid/DataphiGrid'
import Pagination from '../../../HSGPagination/HSGPagination'
import { Glyphicon, Modal } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import CONSTANTS from './../../../../Phi/Constants'

import 'react-datepicker/dist/react-datepicker.css'
import 'react-select/dist/react-select.css'

class HSGStudentGrid extends Component {
    constructor(props) {
        super(props)
        this.state = {
            numberEntered: 0,
            data: this.formatData(props.data || []),
            options: {
                //sizePerPageDropDown: (props) => this.renderSizePerPageDropDown(props),
                paginationPanel: props => this.renderPaginationPanel(props),
                //paginationShowsTotal: (start, to, total) => this.paginationShowsTotal(start, to, total),
                onPageChange: (page, sizePerPage) => this.onPageChange(page, sizePerPage),
                //onSizePerPageList: this.sizePerPageListChange.bind(this),
                onSortChange: (sn, so) => this.onSortChange(sn, so),
                onAddRow: row => this.onAddRow(row),
                toolBar: props => this.toolbar(props),
                // searchPanel: props => this.searchPanel(props)
            },
            currSizePerPage: '10',
            parameters: {
                pageNum: 1,
                length: 10
            },
            total: props.total,
            showEditStudentModal: false,
            editableRow: {},
            inSearchString: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data) || this.props.total !== nextProps.total) {
            this.setState({
                data: this.formatData(nextProps.data),
                total: nextProps.total
            })
        }
    }


    formatData = data => {
        if (!!!data) {
            return []
        } else {
            let genderMap = {
                "M": "MALE",
                "F": "FEMALE",
                "O": "OTHER"
            }
            let newData = data.map((d, i) => {

                let d_object = {
                    uuid: d.hsg_id,
                    studentname: 'NA',
                    class: 'NA',
                    section: 'NA',
                    gender: 'NA',
                    dob: 'NA',
                    admission_number: 'NA',
                    authenticationcode: 'NA'
                }
                d_object.status = d.report_status
                d_object.studentname = d.firstname
                d_object.dob = d.dob
                d_object.gender = genderMap[d.gender]
                d_object.admission_number = d.admission_number
                d_object.class = d.class
                d_object.section = d.section
                d_object.authenticationcode = d.authentication_code
                return d_object
            })
            return newData
        }
    }

    searchStudent = (e) => {
        const {inSearchString} = this.state
        e.keyCode === 13 && this.props.search(inSearchString.trim())
    }

    toolbar = props => {
        return (
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className='search-box-container'>
                    <input onChange={(e) => this.setState({inSearchString: e.target.value})} onKeyDown={e=>{this.searchStudent(e)}} placeholder="Type in student name or HSG-ID.." className="input-search-box" type='text' value={this.state.inSearchString} />
                </div>
            </div>
        );
    }

    onSortChange = (sortName, sortOrder) => {
        let sortInfo = {
            orderColumn: sortName,
            orderDirection: sortOrder
        }
        let { parameters } = this.state
        parameters = Object.assign(parameters, sortInfo)
        this.props.fetchTableData(parameters)
    }

    onPageChange = (page, sizePerPage) => {
        console.log("page, sizePerPage: ", page, sizePerPage)
    }

    renderPaginationPanel = (props) => {
        const { data, total } = this.state
        const { offset, showNext } = this.props
        return (
            <Pagination
                inOffset={offset}
                showNext={showNext}
                data={data}
                total={total}
                className={'right padding-right-3rem'}
            />
        )
    }

    sizePerPageListChange(sizePerPage) {
        let { parameters } = this.state
        parameters.length = sizePerPage
        this.props.fetchTableData(parameters)
    }

    renderSizePerPageDropDown = props => {
        return (
            <div className='btn-group'>
                {
                    [10, 25, 30].map((n, idx) => {
                        const isActive = (n === props.currSizePerPage) ? 'active' : null;
                        return (
                            <button
                                key={idx}
                                type='button'
                                className={`btn btn-info ${isActive}`}
                                //onClick={() => props.changeSizePerPage(n)}
                                onClick={(e) => this.changeSizePerPage(n, props, e)}
                            >
                                {n}
                            </button>
                        );
                    })
                }
            </div>
        );
    }

    onRowSelect = (row, isSelected, e) => {
        console.log("onRowSelect: ", row, isSelected, e)
    }

    editStudentDetail = (row) => {
        this.setState({
            showEditStudentModal: !this.state.showEditStudentModal,
            editableRow: {...row}
        })
    }

    getActions = (cell, row, unqIdentifier) => row.status >= CONSTANTS.qcCheckedStatusMap.PUBLISHED ? <Glyphicon className="hsg-download" glyph="download" onClick={() => this.props.downloadStudentReport(row.uuid,row.studentname)} /> : <p>NA</p>

    getTableHeader = () => {
        
        return [
            {
                dataField: 'index',
                value: 'Sl.No.',
                width: '20'
            },
            {
                dataField: 'uuid',
                value: 'HSG ID',
                width: '150'
            },
            {
                dataField: 'studentname',
                value: 'STUDENT NAME',
                width: '150'
            },
            {
                dataField: 'class',
                value: 'CLASS',
                width: '100'
            },
            {
                dataField: 'section',
                value: 'SECTION',
                width: '100'
            },
            {
                dataField: 'admission_number',
                value: 'ADMISSION NO.',
                width: '100'
            },
            {
                dataField: 'actions',
                value: 'ACTIONS',
                phiDataFormat: (a, b, c) => this.getActions(a, b, c),
                width: '100'
            }
        ]
    }

    getData = (data = []) => {
        const rowData = data.reduce((newArr, dataElement, index)=>{
            const newDataElement = {
                ...dataElement,
                index: this.props.offset + 1 + index,
            }
            newArr.push(newDataElement)
            return newArr
        }, [])
        return rowData
    }


    render() {
        const { uuid, studentname, phone, authenticationcode } = this.state.editableRow
        
        return (
            <div>
                <DataphiGrid
                    bordered={false}
                    trClassName={'trClassName'}
                    selectRow={this.props.selectRowProp}
                    options={this.state.options}
                    data={this.getData(this.state.data)}
                    pagination
                    keyField={'index'}
                    tableHeaderColumn={this.getTableHeader()}
                    hover
                    search
                    remote={true}
                    tableHeaderClass='my-header-class'
                    tableBodyClass='my-body-class'
                    containerClass='my-container-class'
                    tableContainerClass='hsg-table-cbse'
                    headerContainerClass='my-header-container-class'
                    bodyContainerClass='my-body-container-class'
                />
                <Modal
                    show={this.state.showEditStudentModal}
                    backdrop={true}
                    animation={true}
                    bsSize={'large'}
                    dialogClassName={'student-edit-modal'}
                    onHide={()=>this.editStudentDetail()}
                >
                    <Modal.Header bsClass={'student-edit-modal-hd'}>
                        <Modal.Title>Edit mode</Modal.Title>
                        <span onClick={()=>this.editStudentDetail()} aria-hidden="true" data-icon="&#e90b;" className="icon-close hsg-icon-close"></span>
                    </Modal.Header>

                    <Modal.Body bsClass={'student-edit-modal-bd'}>
                        <div className="row">
                            <div className="hsg-input-grp col-md-5 col-xs-12 col-lg-5 col-sm-12">
                                <label className="hsg-input-label">HSG ID</label>
                                <input disabled className="hsg-input" type="text" value={uuid} />
                            </div>
                            <div className="right hsg-input-grp col-md-5 col-xs-12 col-lg-5 col-sm-12">
                                <label className="hsg-input-label">AUTHENTICATION CODE</label>
                                <input className="hsg-input" type="text" value={authenticationcode} />
                            </div>
                            <div className="hsg-input-grp col-md-5 col-xs-12 col-lg-5 col-sm-12">
                                <label className="hsg-input-label">STUDENT NAME</label>
                                <input className="hsg-input" type="text" value={studentname} />
                            </div>
                            <div className="right hsg-input-grp col-md-5 col-xs-12 col-lg-5 col-sm-12">
                                <label className="hsg-input-label">CONTACT NUMBER</label>
                                <input className="hsg-input" type="text" value={phone} />
                            </div>
                            <div className="hsg-input-grp date-icon col-md-5 col-xs-12 col-lg-5 col-sm-12">
                                <label className="hsg-input-label">REMINDER</label>
                                <DatePicker className={`hsg-input-date`}
                                    selected={moment()}
                                    onChange={this.handleChange}
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                    dateFormat="DD/MM/YYYY"
                                    calendarClassName={'datepicker-calendar'}
                                />
                                {/* <input className="hsg-input-date" type="text" value="" /> */}

                                <HSGStudentGrid
                                
                                getActions={this.getActions}
                                
                                />
                            </div>
                            <div className="right hsg-input-grp col-md-5 col-xs-12 col-lg-5 col-sm-12">
                                <label className="hsg-input-label">REMARKS</label>
                                <input className="hsg-input" type="text" value="" />
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer bsClass={'student-edit-modal-ft'}>
                        <span className="cursor-pointer" onClick={()=>this.editStudentDetail()}>Cancel</span>
                        &nbsp; &nbsp; &nbsp;
                        <button className="hsg-btn">Save</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default HSGStudentGrid